import { createFileRoute, Navigate } from "@tanstack/react-router"
import { useProjectEditContext } from "@/features/project-editor/context/ProjectEditContext"
import { ProcessPage } from "@/features/project-editor/process/processRoute"
import { usePermissions } from "@/hooks/usePermissions"

export const Route = createFileRoute("/(authenticated)/projects/edit/$projectId/process")({
  component: ProcessRouteComponent,
})

function ProcessRouteComponent() {
  const { projectId } = Route.useParams()
  const context = useProjectEditContext()

  // Access control: Block store_manager and external_viewer from project edit screens
  // Wait for permissions to load to avoid redirect flash on page refresh
  const { hasPermission, role, isLoading: permissionsLoading } = usePermissions()
  const canAccessEditScreen =
    hasPermission("project", "update").allowed || role === "store_designer"

  // Don't redirect while permissions are still loading
  if (!permissionsLoading && !canAccessEditScreen) {
    return <Navigate to="/projects" />
  }

  // Use readOnly from parent context (includes edit mode + permission check)
  // Fallback to permission-only check if context not yet available
  const readOnly = context?.readOnly ?? !hasPermission("project", "update").allowed

  return <ProcessPage projectId={projectId} readOnly={readOnly} />
}
